export default {

    'formulario': {
        namespaced: true,
        ...require('@/aplicacao/modulos/box/formulario/_store').default,
    },

}
